'use client';

import { useQueryClient } from '@tanstack/react-query';

import { QUERY_KEY_IS_AUTHORIZED } from './constants';
import { getIsUserAuthorized } from './utils';

const useIsAuthorizedNext = () => {
    const queryClient = useQueryClient();

    return queryClient.getQueryData<boolean>([QUERY_KEY_IS_AUTHORIZED]) ?? false;
};

/**
 * Returns whether the current user is authorized.
 *
 * In Next.js apps, reads the value prefetched server-side via {@link IsAuthorizedProvider}.
 * In React apps, checks cookies directly via {@link getIsUserAuthorized}.
 */
export let useIsAuthorized: () => boolean;

if (process.env.IS_NEXT === 'true') {
    useIsAuthorized = useIsAuthorizedNext;
} else {
    useIsAuthorized = getIsUserAuthorized;
}
